import { createSelector } from 'reselect';
import { tooltipSelector } from './simple-selector';

export const tooltipRequestsSelector = createSelector(
    tooltipSelector,
    (tooltip) => tooltip.requests
);
